export default [
  {
    id: 1,
    title: "One Day Classic Lash",
    p1: "Private one day class for classic lash extension training.",
    p2: "Includes safety & sanitation, product resources, isolation, pick-up, placement, tweezer practice, business and marketing, and full set practice on a mannequin. ",
    p3: "Comes with a fully loaded kit.",
    hours: "5 hr",
    price: "$850",
    license:
      "*Licensed estheticians or cosmetologist can legally accept a certification by me in the state of North Carolina. Non- licensed students wishing to take this course will receive a course completion certificate",
  },
  {
    id: 2,
    title: "Two Day Classic Lash",
    p1: "Private two day class for classic lash extension training",
    p2: "Course includes safety & sanitation, product resources, isolation, pick-up, placement, tweezer practice, business and marketing, mannequin practice (day 1), live model practice (day 2) ",
    p3: "Class will come with a fully loaded kit.",
    hours: "2 Days",
    price: "$1000",
    license:
      "*Licensed estheticians or cosmetologist can legally accept a certification by me in the state of North Carolina. Non- licensed students wishing to take this course will receive a course completion certificate",
  },
];
